module.exports = __webpack_public_path__ + "img/pic_20s.54068a13.gif";